module.exports = __webpack_public_path__ + "static/media/landing.e43272e1.jpg";